(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('FirebaseToken', FirebaseToken);

    FirebaseToken.$inject = ['$resource', 'DateUtils'];

    function FirebaseToken ($resource, DateUtils) {
        var resourceUrl =  'api/firebase-tokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'getByProfile': {method: 'GET', url: 'api/firebase-token/:profileId/languages', isArray: true},
            'getOneByCustomer': {method: 'GET', url: 'api/firebase-token/:customerId/language'},
            'update': { method:'PUT' }
        });
    }
})();
